<template><div class="input-group-text"><slot /></div></template>
<script>export default { name: "SbInputGroupText" };</script>
